<div class="container-fluid mt-4" *ngIf="contract">
  <div class="col-md-10 offset-md-1">
    <po-comments [poID]="contract?.id" [comments]="contract?.comments" [userId]="currentUser?.id">
    </po-comments>
  </div>
</div>
